<h2 *ngIf="title">{{ title }}</h2>
<h3 *ngIf="subtitle">{{ subtitle }}</h3>
<ngx-contentful-rich-text
  [document]="richText"
  [nodeRenderers]="nodeRenderers"
  *ngIf="richText"
></ngx-contentful-rich-text>
<ng-content select="[panel-content]"></ng-content>
